// @flow

import { BaseGeoJsonEditMode } from './geojson-edit-mode.js';

export class ViewMode extends BaseGeoJsonEditMode {}
